import axios from 'axios';
import { baseUrl } from '@/config';

const PREFIX_URL = `${baseUrl}/smart-search`;

export default {
  /**
   * 최근 검색기록을 조회한다.
   * @author Hunui
   * @param  {[type]} param
   * @return {[type]} axios
   */
  getSearchHist(param) {
    return axios.post(`${PREFIX_URL}/get-search-hist.do`, param);
  },
  /**
   * 최근 검색기록을 추가한다.
   * @author Hunui
   * @param  {[type]} param
   */
  addSearchHist(param) {
    return axios.post(`${PREFIX_URL}/add-search-hist.do`, param);
  },
  /**
   * 최근 검색기록을 삭제한다.
   * @author Hunui
   * @param  {[type]} seqNumber [description]
   * @return {[type]}           [description]
   */
  deleteSearchHist(seqNumber) {
    return axios.post(`${PREFIX_URL}/delete-search-hist.do`, { seqNumber });
  },
  /**
   * 검색어 자동완성 목록을 조회한다.
   * @author Hunui
   * @param  {[type]} searchKeyword 검색키워드
   */
  getAutoCompletionList(searchKeyword) {
    return axios.post(`${PREFIX_URL}/get-auto-completion-list.do`, { searchKeyword });
  },
  /**
   * 검색 결과를 조회한다.
   * @author Hunui
   * @param  {[type]} searchKeyword 검색키워드
   */
  getSearchResult(searchKeyword, pageSize) {
    return axios.post(`${PREFIX_URL}/get-search-result.do`, { searchKeyword, limit: pageSize });
  },
  /**
   * 선택한 검색 결과에 대한 트리키 생성
   * @author jeee12
   * @param  {[type]} params        [description]
   * @return {[type]}               [description]
   */
  getTreeKey(params) {
    return axios.post(`${PREFIX_URL}/get-tree-key.do`, params);
  },
  /**
   * 메뉴의 검색 항목별 검색 결과 조회 (페이징 처리 수행)
   * @author jeee12
   * @param  {[type]} params        [description]
   * @return {[type]}               [description]
   */
  getSearchResultByMenuType(params) {
    return axios.post(`${PREFIX_URL}/get-search-result-by-menu-type.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/frame/smart-search.js